<div class="estadocontainer">
  <div class="estadobackups" *ngIf="(globales.backupConfigurado | async) as estadoBackup">
    <div *ngIf="estadoBackup == -1"><ion-spinner name="circles"></ion-spinner></div>
    <div *ngIf="estadoBackup == 2" class="backupEstado backupError">
      <ion-icon name="alert-circle" (click)="popoverError.isOpen = true; popoverError.event = $event"></ion-icon>
      <ion-popover mode="ios" #popoverError [backdropDismiss]="true" (didDismiss)="popoverError.isOpen= false">
        <ng-template>
          <ion-content class="ion-padding" [style.fontSize]="'0.9rem'">
            Las copias de seguridad no están funcionando correctamente.
          </ion-content>
        </ng-template>
      </ion-popover>
    </div>
    <div *ngIf="estadoBackup == 1" class="backupEstado backupCorrecto">
      <ion-icon name="checkmark-circle" (click)="popoverError.isOpen = true; popoverError.event = $event"></ion-icon>
      <ion-popover mode="ios" #popoverError [backdropDismiss]="true" (didDismiss)="popoverError.isOpen= false">
        <ng-template>
          <ion-content class="ion-padding" [style.fontSize]="'0.9rem'">
            Las copias de seguridad están funcionando correctamente.
          </ion-content>
        </ng-template>
      </ion-popover>
    </div>
  </div>
  <div class="estadoaplicacion" *ngIf="(globales.estadoAplicacion | async) as estado" >
    <div *ngIf="estado == 'Actualizada'" class="itemEstado actualizada"><span><ion-icon name="reload-outline"></ion-icon>Aplicación actualizada</span> </div>
    <div *ngIf="estado == 'Descargando'" class="itemEstado descargando"><span><ion-icon name="download-outline"></ion-icon>Descargando actualización...</span> </div>
    <div *ngIf="estado == 'ActualizacionPendiente'" class="itemEstado pendiente"><span><ion-icon name="hourglass-outline"></ion-icon>Actualización pendiente <a href="javascript:void(0)" (click)="reload()">Recargar</a></span></div>
    <div *ngIf="estado == 'NoServiceWorker'" class="itemEstado actualizada"><span><ion-icon name="reload-outline"></ion-icon>Service worker no disponible</span></div>
  </div> 
</div>
